import { Switch, Tooltip } from "@material-ui/core";
import styled from "styled-components";
import { HFlex, Pane, Text, useErrorContext, Loading } from "shared";
import { Breakpoint, SPACING } from "theme";
import { useTranslation } from "react-i18next";
import { useId } from "utils/hooks";
import { useHcpFeatureFlags, useUpdateHcpFeatureFlag } from "api/hooks/useHCPs";

const Grid = styled.div`
  display: grid;
  gap: ${SPACING}px;
  @media screen and (max-width: ${Breakpoint.lg - 1}px) {
    grid-template-columns: 1fr;
  }
  @media screen and (min-width: ${Breakpoint.lg}px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const ToggleFeatures: React.VFC = () => {
  const hcpId = useId();
  const { t } = useTranslation();
  const setErrors = useErrorContext();
  const { data, isLoading } = useHcpFeatureFlags();
  const updateFeatureFlag = useUpdateHcpFeatureFlag(setErrors);

  const featureFlags = data?.feature_flags ?? [];

  const handleChange = (flag: string, currentEnabled: boolean) => {
    updateFeatureFlag.mutate({ hcpId, flag, enabled: !currentEnabled });
  };

  if (isLoading) return <Loading />;

  return (
    <>
      <Text paragraph caption secondary>
        {t`hcp.feature_toggle_title`}
      </Text>
      <Pane dark p={1}>
        <Grid data-testid="feature-toggle">
          {featureFlags.map(({ flag, description, enabled }) => (
            <Pane key={flag} component="label" role="button" mb={0} py={0.5}>
              <HFlex justifyContent="space-between" alignItems="center">
                <Tooltip placement="top" title={description ?? ""}>
                  <Text light small>
                    {flag}
                  </Text>
                </Tooltip>
                <Switch
                  checked={enabled}
                  onChange={() => handleChange(flag, enabled)}
                  color="primary"
                />
              </HFlex>
            </Pane>
          ))}
        </Grid>
      </Pane>
    </>
  );
};

export default ToggleFeatures;
